// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';
import InitialConfigHeader from '../../../components/InitialConfig/UserInitialConfigHeader'
import StepIntro from '../../../components/InitialConfig/StepIntro'
import AsideMapMenu from '../../../components/InitialConfig/AsideMapMenu'
import Loader from '../../../components/Utils/Loader'
import WorkflowNavigationButtons from '../../../components/InitialConfig/WorkflowNavigationButtons';
import WorkflowIlustration from "../../../components/InitialConfig/WorkflowIlustration";
import FormValidationError from "../../../components/InitialConfig/FormValidationError";
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const updateInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/updateInstallationConfiguration"
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js");
var generalCommonJS = require("../../../js/generalCommon.js")

// Initial config - Meteo
const Meteo = () => {

  const [illustrationElements, setIllustrationElements] = useState([])
  const [jsonConfigData, setJsonConfigData] = useState({})
  
  useEffect(() => {    

    if(initialConfigCommonJS.antiBackOnboarding() === false){

      if(localStorage.getItem("installationConfigurationMode") === null){
        localStorage.removeItem("currentInstallationConfiguration")
        localStorage.removeItem("configuredApps")
        generalCommonJS.registrarEventoAnalitica(ReactGA, 'REGISTRO', 'REGISTRO - METEO', "", "")
      }

      initialConfigCommonJS.actualizarPasoWorkflowEnBBDD("METEO")    
      
      if(localStorage.getItem("currentInstallationConfiguration") !== null){        
        procesarConfiguracionActual(JSON.parse(localStorage.getItem("currentInstallationConfiguration")))
      }
      else{
        cargarConfiguracionActualPaso()        
      }
      
      if(localStorage.getItem("installationConfigurationMode") !== null){
        document.getElementById("meteo").className = "step"      
        initialConfigCommonJS.visibilidadModoConfiguracion()
        document.getElementById("initialConfigBreadcrumb").className = document.getElementById("initialConfigBreadcrumb").className.replaceAll(" hidden", "") + " hidden"
      }
      else{
        document.title = "HELIAS - Configuración inicial: Información meteorológica"
      }
    }

  }, []);

  function procesarConfiguracionActual(jsonRespuesta){
    
    setJsonConfigData(jsonRespuesta)

    if(jsonRespuesta.Meteo.toString().length > 0){        
                
      var configuracionPasoActual = jsonRespuesta.Meteo

      document.getElementById("avatarMeteoStFigure").className = "avatar size-m cyan"
      document.getElementById("avatarMeteoStSpan").innerHTML = "person_pin_circle"
      document.getElementById("estacionSeleccionadaSpan").innerHTML = configuracionPasoActual.WeatherStationID
      document.getElementById("estacionSeleccionada").value = configuracionPasoActual.WeatherStationID
      
      document.getElementById("fieldsetEstacionMeteorologicaActual").className = document.getElementById("fieldsetEstacionMeteorologicaActual").className.replaceAll(" hidden", "")

      document.getElementById("estacionesAuxiliares").value = configuracionPasoActual.AuxiliaryWeatherStations
    
    }
    
    setIllustrationElements(initialConfigCommonJS.cargaInicialIlustracion(jsonRespuesta))

    //Si no hay datos configurados entonces no hago nada

    document.getElementById("loaderMeteo").className = document.getElementById("loaderMeteo").className.replaceAll(" hidden", "") + " hidden"
 
  }

  function cargarConfiguracionActualPaso(){

    document.getElementById("loaderMeteo").className = document.getElementById("loaderMeteo").className.replaceAll(" hidden", "") 

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "GeneralInfo": "",
      "Meteo": "",
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{     
            procesarConfiguracionActual(jsonRespuesta.body)            
            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {  
          initialConfigCommonJS.mostrarMensajeInformativo('Se produjo un error al cargar la configuracion.',"negative")
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }
  
  function guardarInformacionPaso(direccion){
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  
    
    document.getElementById("loaderMeteo").className="loader overlay"
  
    //Preparo los datos necesarios para el json
    
    var estacionesAuxiliares = document.getElementById("estacionesAuxiliares").value.replaceAll(document.getElementById("estacionSeleccionada").value+"|", "").replaceAll("|"+document.getElementById("estacionSeleccionada").value, "").replaceAll(document.getElementById("estacionSeleccionada").value, "")

    var jsonGeneralMeteo = {
      "WeatherStationID": document.getElementById("estacionSeleccionada").value,
      "AuxiliaryWeatherStations": estacionesAuxiliares
    }
  
    var jsonGuardado = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "Meteo": jsonGeneralMeteo,
      "GeneralInfo": jsonConfigData.GeneralInfo
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", updateInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonGuardado);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuestaGuardado = JSON.parse(this.responseText)
          if(jsonRespuestaGuardado.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            console.log("Información guardada correctamente")
            // Y continuo a la siguiente página    
            if(localStorage.getItem("installationConfigurationMode") === null){
              if(localStorage.getItem("ongoingStepConfiguration") === "METEO" ){      
                initialConfigCommonJS.navegarDinamico(direccion)
              }
              else{
                initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
              }
            }
            else{
              initialConfigCommonJS.mostrarMensajeInformativo("Configuración guardada correctamente","positive")
              document.getElementById("asideDetalleConfiguracion").className += " hidden"
              document.getElementById("loaderMeteo").className="loader hidden"
            }
          }
          
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }

  function validacionCamposCorrecta(){

    document.getElementById("divSelectorEstacionMeteorologica").className = document.getElementById("divSelectorEstacionMeteorologica").className.replaceAll(" error","")

    var numeroErroresValidacion = 0
    
    if(document.getElementById("estacionSeleccionada").value === ""){
      numeroErroresValidacion++
      document.getElementById("divSelectorEstacionMeteorologica").className = document.getElementById("divSelectorEstacionMeteorologica").className + " error"
    }

    if(numeroErroresValidacion > 0){      
      document.getElementById("divErrorValidacionFormulario").className="message error left"
      return false
    }
    else{
      document.getElementById("divErrorValidacionFormulario").className="message error left hidden"
      return true
    }

  }
  
  function navegar(direccion){
    if(initialConfigCommonJS.existeSesion()){
      if(direccion === "continuar"){    
        if(validacionCamposCorrecta()){
          if(document.getElementById("contenedorPrincipalOpcion") !== null){
            document.getElementById("contenedorPrincipalOpcion").scrollTop = 0
          }
          guardarInformacionPaso(direccion)
        }
      }
      else{
        if(localStorage.getItem("ongoingStepConfiguration") === "METEO"){      
          initialConfigCommonJS.navegarDinamico(direccion)
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo('Todavía no he cargado la información para continuar, me has pillado despistao, inténtalo de nuevo ahora a ver...',"")
        }
      }
    }
  }

  return (          
    
    <main id="divMainContenedorStep">      

      <InitialConfigHeader step={"METEO"}/>

      <section id="meteo" className="step wrapper">

        <div id="divContenedorStep" className="content-wrapper half">          

          <StepIntro 
            Title="Estación meteorológica" 
            Intro={<>
            <p>Genial, ahora configuremos tu estación meteorológica más cercana y así sabré por ejemplo: si hace sol, está lloviendo, está nublado, la velocidad del viento, etc... Si tu instalación no está en un núcleo urbano puedes pulsar el icono del lapiz y ver si hay alguna otra que se ajuste mejor a su ubicación.</p>                        
            </>} 
          />

          <fieldset id="fieldsetEstacionMeteorologicaActual" className="">
            <legend>Estación actual</legend>
            <div id="divSelectorEstacionMeteorologica" className="selection icon-wrapper" onClick={() => initialConfigCommonJS.operarMenuMapaLateral("abrir")}>
              <figure id="avatarMeteoStFigure" className="avatar size-m loading"><span id="avatarMeteoStSpan" className="material-icon">location_searching</span></figure>
              <span id="estacionSeleccionadaSpan" className="label">Buscando estación más cercana...</span>
              <p id="estacionSeleccionadaP" className="additional-data uppercase size-s"></p>
              <input type="text" id="estacionSeleccionada" style={{display: "none"}}/>
            </div>
          </fieldset>

          <input type="text" id="estacionesAuxiliares" className=" hidden"/>
          
          <FormValidationError/>

          <WorkflowNavigationButtons step={"METEO"} navegar={navegar}/>
          
        </div>

        { localStorage.getItem("installationConfigurationMode") === null
          ? <WorkflowIlustration illustrationElements={illustrationElements}/>
          : <></>
        }

        <Loader Id="loaderMeteo" Mensaje=""/>

      </section>

      <AsideMapMenu jsonConfigData={jsonConfigData}/>

    </main>
    
  )
}

export default Meteo